import NiceModal, { useModal } from '@ebay/nice-modal-react'
import PopupMask from "@/componentsUI/PopupMask"
import { useBeforeSetting } from "@/store/beforeSetting"
import ButtonUI from "@/componentsUI/Button"
import React from "react"

const StopService = NiceModal.create(() => {
    const { data } = useBeforeSetting()
    const { visible, resolve, remove } = useModal()
    const prefixCls = 'stop-service';

    const handleClose = () => {
        resolve();
        remove();
    };

    return (
        <PopupMask visible={visible}>
            <div className={`${prefixCls}-body`}>
                <div className="message">
                    <span className="message-text">{data?.wnoticeVO?.noticeComment}</span>
                </div>
                <div className="btns">
                    <ButtonUI type={"primary"} className="btn" onClick={handleClose}>
                        OK
                    </ButtonUI>
                </div>
            </div>
        </PopupMask>

    )
})

export default StopService
